import BaseAPI from './base'

class FavoriteCourseAPI extends BaseAPI {}

export default new FavoriteCourseAPI('v1/favorite-course', 'FavoriteCourse')
